import { DatePicker } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { isLocked, leagueStart } from '../../config/constants'
import { updateDate } from '../../redux'
import dayjs from 'dayjs'

const HeadingAndDate = ({ heading, datePicker = true }) => {
  const { setting } = useSelector((state) => state.user)

  return (
    <>
      <div className='heading_and_date'>
        {heading ? <h2>{heading}</h2> : <div />}
        {datePicker ? setting?.date === 'demo' ? <p>| Demo |</p> : <DatePickerComp /> : <div />}
      </div>

      {isLocked() && !window.location.href?.includes('/leagueScore') && (
        <div className='locked_box'>
          <p>You are viewing previous day data in view only mode.</p>
        </div>
      )}
    </>
  )
}

const DatePickerComp = () => {
  const { date: currentDate } = useSelector((state) => state?.user?.setting)
  const SETTING = useSelector((state) => state?.user)

  const dispatch = useDispatch()

  const disabledDate = (current) => {
    const currentDay = dayjs(current)
    const minDate = dayjs(leagueStart)
    const maxDate = dayjs(SETTING.currentDate)
    return currentDay.isBefore(minDate) || currentDay.isAfter(maxDate)
  }
  return (
    <div className='date_picker_box'>
      <DatePicker
        inputReadOnly={true}
        placeholder='Select Date'
        value={dayjs(currentDate)}
        onChange={(_, dateString) => {
          dispatch(updateDate(dateString))
        }}
        disabledDate={disabledDate}
        allowClear={false}
      />
    </div>
  )
}

export default HeadingAndDate
